import React from 'react'
import { FormationService } from '../../../../services/formationService'
import logger from '../../../../utils/logger'
import { toast } from 'react-toastify'
import './formationAlert.css'

export const FormationAlert = ({ selectedAction, selectedMember, closeBootstrapModal, FormationId, refetch, validateAddition }) => {


    logger.debug('selectedMember: ', selectedMember)


    const actionToast = (text, type) => {

        toast.success(text, {
            autoClose: 2000
        })

    }

    const errorToast = (text) => {
        toast.error(text, {
            autoClose: 2000
        })
    }


    const handleConfirm = async () => {
        try {

            if (selectedAction?.apiKey === 'add' && validateAddition) {
                errorToast('La formación se encuentra llena')
                return
            }

            const response = await FormationService.executeMemberAction(selectedAction, selectedMember, FormationId)

            if (response && response.status === 200) {
                // logger.warn('response: ', response)
                actionToast(response.data?.message)
                refetch()
            }
            closeBootstrapModal()
        } catch (err) {
            logger.error(err)
            errorToast(err.response?.data?.message)
            closeBootstrapModal()
        }
    }

    return (
        <div className="modal-content contentWidhtRenovation">


            <div className="modal-body mbodyR-class">

                <div className="spanE-container formation-alert-icon-container">
                    <span className="material-symbols-outlined formation-alert-icon-error">
                        error
                    </span>
                    {/* <span className="material-symbols-outlined mI-error">warning</span> */}
                </div>



                <p className="renovation-title">
                    {selectedAction?.title}
                </p>

                <p className="renovation-text">
                    ¿Quieres <b>{selectedAction?.verb}</b> a <b>{selectedMember?.name} {selectedMember?.lastname}</b>?
                </p>

                <div className="btns-cancel-renovation">

                    <button
                        className="btn-sr btn-sr-width btn btn-success"
                        id="saveButton"
                        aria-label="Close"
                        onClick={handleConfirm}
                    >Si, {selectedAction?.verb}</button>

                    <button className="btn-cancel btn-sr-cancel"
                        aria-label="Close" id="cancelButton" onClick={closeBootstrapModal}>Cancelar</button>

                </div>


            </div>
        </div>
    )
}
